<template>
  <div>
    <a-button type="primary" @click="showAdd" v-if="ableAdd">添加流程定义</a-button>
    <a-modal
      v-model:open="open"
      :title="isEdit ? '编辑流程定义' : '添加流程定义'"
      :footer="null"
      :destroyOnClose="true"
      style="width: 90vw; height: 80vh"
    >
      <add-process
        :v-if="open"
        @submit="clickOk"
        :isEdit="isEdit"
        :editData="editData"
        :treeData="treeData"
        :data="tableData"
      ></add-process>
    </a-modal>
    <a-table
      :columns="columns"
      :row-key="(record) => record.uuid"
      :data-source="tableData"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
      :scroll="{x: 'max-content'}"
      size="small"
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.key === 'process_list'">
          <!--{{ formatProcessList(record) }}-->
          <div
            style="
              border: 1px solid #a7a7e9;
              border-radius: 5px;
              display: inline-block;
              padding: 5px;
            "
          >
            <div
              v-for="(item, index) in record.definitionNodeList"
              :key="item.definitionNodeId"
            >
              <div
                v-if="index !== 0"
                style="
                  color: rgb(30 30 255);
                  font-size: 20px;
                  height: 15px;
                  line-height: 15px;
                  font-weight: 900;
                "
              >
                ↓
              </div>
              {{ item.name }}
            </div>
          </div>
        </template>
        <template v-if="column.key === 'create_user'">
          {{ record?.createUser?.user_name || '' }}
        </template>
        <template v-if="column.key === 'create_time'">
          {{ record?.create_time || '' }}
        </template>

        <template v-if="column.key === 'action'">
          <span>
            <a-button @click="showEdit(record)" v-if="ableEdit">编辑</a-button>
            &nbsp;&nbsp;
            <a-popconfirm
              title="确认删除？"
              ok-text="确认"
              cancel-text="取消"
              @confirm="delRow(record)"
              v-if="ableDelete"
            >
              <a-button danger>删除</a-button>
            </a-popconfirm>
          </span>
        </template>
      </template>
    </a-table>
  </div>
</template>
<script setup>
  import { ref, onMounted, computed } from 'vue'
  import { useStore } from 'vuex'
  import { getProcDef, deleteProcDef } from '@/api/process'
  import { getDept } from '@/api/system_manage/dept'
  import { buildTree } from '@/utils/tree'
  import AddProcess from './addProcess'
  import { message } from 'ant-design-vue'
  const store = useStore()

  const permissionList = computed(() => store.getters['user/permissionList'])
  const ableAdd = computed(() =>
    !!permissionList.value?.find(item => item.code === 'processDefinition:add')
  )
  const ableEdit = computed(() =>
    !!permissionList.value?.find(item => item.code === 'processDefinition:edit')
  )
  const ableDelete = computed(() =>
    !!permissionList.value?.find(item => item.code === 'processDefinition:delete')
  )

  //1、表格
  const columns = [
    {
      title: '名称',
      dataIndex: 'name',
      key: 'name',
      align: 'left',
    },
    {
      title: '流程节点',
      dataIndex: 'process_list',
      key: 'process_list',
      align: 'left',
    },
    {
      title: '备注',
      dataIndex: 'remark',
      key: 'remark',
      align: 'left',
    },
    {
      title: '创建人',
      dataIndex: 'create_user',
      key: 'create_user',
      align: 'left',
    },
    {
      title: '创建时间',
      dataIndex: 'create_time',
      key: 'create_time',
      align: 'left',
    },
    {
      title: '操作',
      dataIndex: 'action',
      key: 'action',
      align: 'left',
      fixed: 'right',
      width: '190px',
    },
  ]

  const tableData = ref([])
  const loading = ref(false)
  const pagination = ref({
    current: 1,
    pageSize: 10,
    showLessItems: true,
    showQuickJumper: true,
    showSizeChanger: true,
    showTotal: (total, range) => {
      return `共 ${total} 条`
    },
  })
  const treeData = ref([])

  function handleTableChange(page) {
    pagination.value = { ...pagination.value, ...page }
    fetch()
  }

  function formatProcessList(record) {
    if (!record?.definitionNodeList?.length) return ''
    return record.definitionNodeList.map((item) => item.name).join(' -> ')
  }

  function fetch() {
    loading.value = true
    getProcDef({
      size: pagination.value.pageSize,
      pn: pagination.value.current,
    }).then(({ data }) => {
      loading.value = false
      tableData.value = data
      pagination.value.total = data.total
    })
    getDept().then(({ data }) => {
      const tree = buildTree(data, { idName: 'depart_id' })
      treeData.value = tree
    })
  }
  onMounted(fetch)

  //2、编辑、添加
  const open = ref(false)
  const isEdit = ref(false)
  const editData = ref(null)

  const showAdd = () => {
    editData.value = null
    isEdit.value = false
    open.value = true
  }
  const showEdit = (data) => {
    editData.value = data
    isEdit.value = true
    open.value = true
  }

  function clickOk() {
    fetch()
    handleOk()
    clearEditData()
  }

  const handleOk = () => {
    open.value = false
  }
  const clearEditData = () => {
    editData.value = null
  }

  //3、删除
  async function delRow(data) {
    const res = await deleteProcDef({
      processDefinitionId: data.process_definition_id,
    })
    if (res.success) {
      message.success('删除成功！')
      fetch()
    } else {
      message.warn('删除失败' + res.message)
    }
  }
</script>
